import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: ",
        "px;\n  padding: 20px;\n  background-color: ",
        ";\n  border-radius: 10px;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: -0.14px;\n\n  dt,\n  dd p {\n    color: ",
        ";\n  }\n  dt {\n    padding: 8px 12px;\n    font-weight: 600;\n  }\n  dd {\n    margin-bottom: 0;\n    padding-top: 4px;\n\n    p {\n      padding: 4px 12px;\n    }\n  }\n\n  @media (max-width: 1200px) {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: ",
        "px;\n    padding: 20px 8px;\n    border-radius: 0;\n\n    body:has(.gnb) & {\n      top: ",
        "px;\n    }\n\n    dl {\n      padding-bottom: 8px !important;\n    }\n    dt {\n      display: none;\n    }\n    dd {\n      padding-top: 0;\n    }\n\n    ul {\n    }\n    li {\n      margin-bottom: 8px !important;\n    }\n\n    button {\n      padding: 11px 4px;\n      flex-direction: column;\n      font-size: 12px;\n      font-weight: 400;\n\n      &.ant-btn-text:has(label) {\n        background-color: transparent;\n      }\n      svg {\n        width: 32px;\n        height: 32px;\n        margin-right: 0;\n        margin-bottom: 4px;\n      }\n      span {\n        display: block;\n        width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        &.extra {\n          display: none;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  padding: 0 4px;\n\n  .ant-divider {\n    margin: 10px 0 18px;\n    border-color: ",
        ";\n  }\n  @media (min-width: 1201px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  max-height: ",
        ";\n  margin-bottom: 0;\n\n  &:not(:last-of-type) {\n    padding-bottom: 40px;\n  }\n  &:last-of-type {\n    padding-bottom: 16px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  svg {\n    width: 18px;\n    height: 18px;\n    margin-right: 4px;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  justify-content: flex-start !important;\n  padding: 8px 12px !important;\n  background-color: transparent !important;\n  border-radius: 4px !important;\n  color: ",
        " !important;\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: -0.16px !important;\n\n  &.active,\n  &:hover {\n    background-color: rgba(169, 175, 199, 0.1) !important;\n    color: ",
        " !important;\n  }\n  svg {\n    width: 22px;\n    height: 22px;\n    margin-right: 4px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  max-height: 340px;\n  overflow: auto;\n  margin-right: -2px;\n  padding-right: 2px;\n  li:not(:last-of-type) {\n    margin-bottom: 4px;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  svg {\n    color: ",
        ";\n    transition: 0.2s all;\n  }\n\n  &.active,\n  &:hover {\n    svg {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NewClass from "@/components/Class/NewClass";
import FilledButton from "@/components/common/Button/FilledButton";
import Icon from "@/components/icon/Icon";
import { Class1, Library, PlayableMedia, Plus1_5 } from "@/components/icon/IconList";
import { UserSourceStepModal } from "@/components/Landing/modals/UserSourceStepModal";
import { GNBHeight } from "@/containers/Header/GNB.style";
import { useAuthStore } from "@/lib/auth/AuthStore";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { CLASS_INDEX_PAGE, LIBRARIES_INDEX_PAGE } from "@/settings/constant";
import { useQuery } from "@tanstack/react-query";
import { Divider } from "antd";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo } from "react";
import { fetchClasses } from "src/api/class";
import useClassStore from "src/store/class";
import { useMainPageStore } from "src/store/main";
import { useModal } from "src/utils/overlay";
import styled from "styled-components";
import { useLibrarySubject } from ".";
// export const libraryLnbDimensions = { width: 270, gap: 40, widthOnTablet: 92 }
export const libraryLnbDimensions = {
    width: 0,
    gap: 0,
    widthOnTablet: 0
};
const libraryLnbID = "library-lnb";
const LibraryLNBWrapper = styled.aside.withConfig({
    componentId: "sc-43561272-0"
})(_templateObject(), libraryLnbDimensions.width, (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_300, libraryLnbDimensions.widthOnTablet, GNBHeight);
const LibraryDividerWrapper = styled.div.withConfig({
    componentId: "sc-43561272-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_100);
const LibraryLNBDefinitionList = styled.dl.withConfig({
    componentId: "sc-43561272-2"
})(_templateObject2(), (props)=>props.height || "auto");
const NewClassButton = styled(FilledButton).withConfig({
    componentId: "sc-43561272-3"
})(_templateObject3());
const LinkButton = styled(FilledButton).withConfig({
    componentId: "sc-43561272-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_900);
const LibraryLNB = ()=>{
    const { pathname  } = useRouter();
    const [isSelectBooksModalOpen, { open: openSelectBooksModal , close: closeSelectBooksModal  }] = useModal("selectBooksModal");
    const { isLoggedIn  } = useAuthStore();
    const subjectOnLibrary = useLibrarySubject();
    const subjectOnMain = useMainPageStore((state)=>state.subject);
    const { subject , search  } = useMemo(()=>{
        const subject = subjectOnLibrary || subjectOnMain;
        const searchParams = new URLSearchParams();
        searchParams.set("subject", subject);
        return {
            subject,
            search: "?".concat(searchParams.toString())
        };
    }, [
        subjectOnLibrary,
        subjectOnMain
    ]);
    const { data , refetch  } = useQuery([
        "myClasses",
        subject
    ], ()=>fetchClasses({
            offset: 0,
            limit: 9999999,
            subject
        }), {
        enabled: isLoggedIn && !!subject
    });
    const items = useClassStore((state)=>state.mine);
    const selected = useClassStore((state)=>state.selected);
    const { openNewClass , setMine  } = useClassStore((param)=>{
        let { openNewClass , setMine  } = param;
        return {
            openNewClass,
            setMine
        };
    });
    useEffect(()=>{
        if (!data) {
            return;
        }
        setMine(data.data);
    }, [
        data,
        setMine
    ]);
    useEffect(()=>{
        if (!selected || !isSelectBooksModalOpen) {
            refetch();
        }
    }, [
        selected,
        isSelectBooksModalOpen
    ]);
    const { setUserSourceBooks  } = useClassStore((param)=>{
        let { setUserSourceBooks  } = param;
        return {
            setUserSourceBooks
        };
    });
    const handleSubmitSelectedBookList = useCallback(async (selected)=>{
        setUserSourceBooks({
            books: selected
        });
    }, [
        setUserSourceBooks
    ]);
    return /*#__PURE__*/ _jsxs(LibraryLNBWrapper, {
        id: libraryLnbID,
        children: [
            /*#__PURE__*/ _jsxs(LibraryLNBDefinitionList, {
                children: [
                    /*#__PURE__*/ _jsx("dt", {
                        children: "내 콘텐츠"
                    }),
                    /*#__PURE__*/ _jsx("dd", {
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: LIBRARIES_INDEX_PAGE.concat(search),
                            children: /*#__PURE__*/ _jsxs(LinkButton, {
                                type: "text",
                                block: true,
                                className: pathname.startsWith(LIBRARIES_INDEX_PAGE) && "active",
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        icon: Library
                                    }),
                                    "라이브러리"
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LibraryDividerWrapper, {
                children: /*#__PURE__*/ _jsx(Divider, {})
            }),
            /*#__PURE__*/ _jsxs(LibraryLNBDefinitionList, {
                className: "scrollable",
                children: [
                    /*#__PURE__*/ _jsx("dt", {
                        children: "내 클래스"
                    }),
                    /*#__PURE__*/ _jsx("dd", {
                        children: items && items.length ? /*#__PURE__*/ _jsx(MyClassContainer, {
                            children: items.map((param)=>/*#__PURE__*/ {
                                let { id , name  } = param;
                                return _jsx(MyClass, {
                                    id: id,
                                    name: name
                                }, id);
                            })
                        }) : /*#__PURE__*/ _jsx("p", {
                            children: "아직 생성한 클래스가 없습니다."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(NewClassButton, {
                variant: "soft",
                type: "text",
                block: true,
                onClick: ()=>openNewClass(),
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: Plus1_5
                    }),
                    /*#__PURE__*/ _jsxs("label", {
                        children: [
                            "새 클래스",
                            /*#__PURE__*/ _jsx("span", {
                                className: "extra",
                                children: " 만들기"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(NewClass, {}),
            /*#__PURE__*/ _jsx(UserSourceStepModal, {
                closeSelectBooksModal: closeSelectBooksModal,
                isSelectBooksModalOpen: isSelectBooksModalOpen,
                modalType: "selectBooksModal",
                onSubmitSelectedBookList: handleSubmitSelectedBookList
            })
        ]
    });
};
export default LibraryLNB;
const MyClassContainer = styled.ul.withConfig({
    componentId: "sc-43561272-5"
})(_templateObject5());
const MyClassButton = styled(LinkButton).withConfig({
    componentId: "sc-43561272-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_gray_300, (props)=>props.theme.new.colors.sol_gray_900);
const MyClass = (param)=>{
    let { id , name  } = param;
    const { width  } = useWindowDimensions();
    const isTablet = width < 1201;
    const { asPath  } = useRouter();
    const { href , matched  } = useMemo(()=>{
        const href = "".concat(CLASS_INDEX_PAGE, "/").concat(id);
        return {
            href,
            matched: asPath.endsWith(href)
        };
    }, [
        id,
        asPath
    ]);
    return /*#__PURE__*/ _jsx("li", {
        children: /*#__PURE__*/ _jsx(Link, {
            href: href,
            children: /*#__PURE__*/ _jsxs(MyClassButton, {
                type: "text",
                block: true,
                className: matched && "active",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: isTablet ? Class1 : PlayableMedia
                    }),
                    name
                ]
            })
        })
    });
};
